import { render, staticRenderFns } from "./FilterCustomerDrawer.vue?vue&type=template&id=4ef0e63c&scoped=true&lang=pug&"
import script from "./FilterCustomerDrawer.vue?vue&type=script&lang=js&"
export * from "./FilterCustomerDrawer.vue?vue&type=script&lang=js&"
import style0 from "./FilterCustomerDrawer.vue?vue&type=style&index=0&id=4ef0e63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef0e63c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VIcon,VNavigationDrawer,VSpacer})
